import React from 'react';

const ContactForm = () => {
    return (
        <div className="zoho-form-container" style={{
            width: '100%',
            minHeight: '1000px',
            position: 'relative'
        }}>
            <iframe 
                src='https://forms.zohopublic.eu/ampedtherapeutics1/form/ScheduleYourConsultationForm/formperma/aWHyh11TAcGqDsy812C7c-fE1TBONsP4FDqB2Wc2OJY'
                style={{
                    width: '100%',
                    height: '1200px',
                    border: 'none',
                    borderRadius: '10px'
                }}
                title="Service Consultation Form"
                scrolling="auto"
            />
        </div>
    );
};

export default ContactForm;